module.exports = __webpack_public_path__ + "static/media/i_collection.c0c0743f.svg";